import { render, staticRenderFns } from "./collectionLocation.vue?vue&type=template&id=edf57d50&scoped=true&"
import script from "./collectionLocation.vue?vue&type=script&lang=js&"
export * from "./collectionLocation.vue?vue&type=script&lang=js&"
import style0 from "./collectionLocation.vue?vue&type=style&index=0&id=edf57d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf57d50",
  null
  
)

export default component.exports